import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 7,
  path: '/educationalTraining',
  component: Home,
  redirect: '/educationalTraining/education/situation',
  name: 'educationalTraining',
  isHead: true,
  meta: {
    title: '教育培训',
    img: require('@/assets/img/jypx.png')
  },
  children: [
    {
      path: 'education',
      name: 'education',
      component: () => import('@/views/educationalTraining/index'),
      meta: { title: '教育培训', close: false },
      children: [
        {
          path: 'situation',
          name: 'situation',
          component: () => import('@/views/educationalTraining/situation/index'),
          meta: { title: '企业培训情况', next: '/educationalTraining/education/manage', close: false },
        },
        {
          path: 'manage',
          name: 'manage',
          component: () => import('@/views/educationalTraining/manage/index'),
          meta: { title: '企业人员持证管理', next: '/educationalTraining/education/study', close: false },
        },
        {
          path: 'study',
          name: 'study',
          component: () => import('@/views/educationalTraining/study/index'),
          meta: { title: '在线学习', next: '/educationalTraining/education/publicize', close: false },
        },
        {
          path: 'publicize',
          name: 'publicize',
          component: () => import('@/views/educationalTraining/publicize/index'),
          meta: { title: '安全宣传', close: false },
        },
      ],
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/educationalTraining.js